<mat-toolbar class="no-background">
  <span>新規出資申込作成</span>
  <span class="spacer"></span>
  <a mat-button class="add-link" routerLink="/invest">
    <mat-icon>arrow_back</mat-icon>作成せずに戻る
  </a>
</mat-toolbar>

<form [formGroup]="form" (ngSubmit)="submit()" enctype="multipart/form-data">

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>ご希望の運用プラン</mat-label>
    <mat-select formControlName="pool">
      <mat-option *ngFor="let type of InvestPoolTypes" [value]="type" >{{type}}</mat-option>
    </mat-select>
    <mat-hint align="end">
      <span *ngIf="form.get('pool')?.invalid && form.get('pool')?.touched" class="inline-error">
        ご希望の運用プランは必須です　
      </span>
    </mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" style="width: 65%; margin-right: 5%; margin-bottom: 16px;">
    <mat-label>出資予定額</mat-label>
    <input matInput type="number" formControlName="amount">
    <mat-hint align="end">
      <span *ngIf="form.get('amount')?.touched && form.get('amount')?.invalid" class="inline-error">
        出資予定額を入力してください　
      </span>
    </mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" style="width: 30%; margin-bottom: 16px;">
    <mat-label>運用通貨</mat-label>
    <mat-select formControlName="currency">
      <mat-option *ngFor="let cur of InvestCurrencies" [value]="cur" >{{cur}}</mat-option>
    </mat-select>
    <mat-hint align="end">
      <span *ngIf="form.get('currency')?.invalid && form.get('currency')?.touched" class="inline-error">
        運用通貨は必須です　
      </span>
    </mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>出資開始予定月（年月を入力・月初に運用開始されます）</mat-label>
    <input matInput type="month" formControlName="ym">
    <mat-hint align="end">
      <span *ngIf="form.get('ym')?.touched && form.get('ym')?.invalid" class="inline-error">
        出資開始予定月を入力してください　
      </span>
    </mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>連絡事項（400文字まで）</mat-label>
    <textarea matInput formControlName="body" rows="8"></textarea>
    <mat-hint align="end">
      <span *ngIf="form.get('body')?.hasError('maxlength') && form.get('body')?.touched" class="inline-error">
        連絡事項は400文字以内で入力してください　
      </span>
      {{ form.get('body')?.value?.length || 0 }}/400
    </mat-hint>
  </mat-form-field>


  <input type="file" #fileInput hidden multiple (change)="onFileChange($event)"/>

  <pre style="font-size: 13px; text-align: left;">お申し込み書類のアップロード *

 必要書類は、「(1) 新規申込書」と「(2) 本人確認書類」の２種類となります。

(1) 新規申込書　<a href="https://myfxpool.com/application2" target="_blank">ダウンロード</a>
(2) 本人確認書類　住所を確認できる書類をお願いします。
　　　免許証の裏に住所記載の場合は免許証両面の画像をお願いします。</pre>

  <div
    class="drop-zone"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
  >
    <p>ここにファイルをドロップまたは</p>
    <button mat-raised-button color="primary" type="button" (click)="fileInput.click()">ファイルを選択</button>
    <p></p>
    <p>※ファイルは最大10個まで、1ファイルにつき20MB以内でアップロードしてください</p>

    <div *ngIf="selectedFiles.length > 0" class="mt-2">
      <mat-list>
        <mat-list-item *ngFor="let file of selectedFiles; let i = index">
          <div class="file-row">
            <button mat-icon-button color="warn" type="button" (click)="removeFile(i)" aria-label="削除">
              <mat-icon>delete</mat-icon>
            </button>
            <span class="file-size">
              ({{ file.size / (1024 * 1024) | number : '1.2-2' }} MB)
            </span>
            <span class="file-name">
              {{ file.name }}
            </span>
          </div>
        </mat-list-item>
      </mat-list>
    </div>

  </div>

  <mat-error *ngIf="form.get('files')?.hasError('maxFileSize')">
    {{ form.get('files')?.getError('maxFileSize')?.message }}
  </mat-error>

  <div style="text-align: right;">
    <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">
      新規出資依頼を作成
    </button>
  </div>

</form>
